import { type AdminProfile, type UUID } from "@/core/types";
import { isCseProfile } from "@/core/helpers/(predicates)/adminProfile";
import { isLcsw } from "@/core/helpers/(predicates)/lcsw";
import { useCanGrantLcsw } from "@/features/permissions/hooks/useCanGrantLcsw";
import { useUserPermissions } from "@/features/permissions/api/queries/useUserPermissions";

import { LcswPermissionCard } from "./LcswPermissionCard";
import { LcswPermissionSkeleton } from "./LcswPermissionSkeleton";

type LcswPermissionOthersProps = {
  profileData: AdminProfile;
  userId: UUID;
};

// other-CSE view: card is visible to any CSE viewer, but only editable when the viewer has
// can_grant_lcsw — otherwise it reflects the target's real status as a read-only switch
export function LcswPermissionOthers({ profileData, userId }: LcswPermissionOthersProps) {
  const isCse = isCseProfile(profileData);

  const { canGrantLcsw, isLoading: isCheckingGrant } = useCanGrantLcsw({ enabled: isCse });
  const { data: permissions, isLoading } = useUserPermissions({ enabled: isCse, userId });

  if (!isCse || !permissions) return null;
  if (isCheckingGrant || isLoading) return <LcswPermissionSkeleton />;

  return (
    <LcswPermissionCard
      isLcsw={isLcsw(permissions)}
      isReadOnly={!canGrantLcsw}
      userId={userId}
      userName={profileData.name}
    />
  );
}
